__turbopack_context__.v({
  "pageWrapper": "policy-module__H1M6eq__pageWrapper",
  "section": "policy-module__H1M6eq__section",
  "sectionList": "policy-module__H1M6eq__sectionList",
  "sectionText": "policy-module__H1M6eq__sectionText",
  "sectionTitle": "policy-module__H1M6eq__sectionTitle",
  "title": "policy-module__H1M6eq__title",
  "updated": "policy-module__H1M6eq__updated",
});
